import { MihatoMark } from "@/common/components/MihatoMark";
import { useAdminMe } from "@/features/admin-auth/api/adminAuthApi";
import { useAdminLogout } from "@/features/admin-auth/api/adminAuthApi";
import { LogOut } from "lucide-react";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "sonner";

export function AdminLayout() {
  const navigate = useNavigate();
  const { data: me } = useAdminMe();
  const logout = useAdminLogout();

  async function handleLogout() {
    try {
      await logout.mutateAsync();
      navigate("/admin/login", { replace: true });
    } catch {
      toast.error("Error al cerrar sesión. Intentá de nuevo.");
    }
  }

  return (
    <div className="min-h-screen bg-app-bg text-app-ink-1">
      <header className="border-app-border border-b bg-app-surface px-6 py-3">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <div className="flex items-center gap-2.5">
            <MihatoMark className="h-6 w-6 text-app-ink-1" accent />
            <span className="font-medium text-app-ink-2 text-sm">Mihato Admin</span>
          </div>
          <div className="flex items-center gap-4">
            {me?.email && <span className="text-app-ink-3 text-xs">{me.email}</span>}
            <button
              type="button"
              onClick={handleLogout}
              disabled={logout.isPending}
              className="flex items-center gap-1.5 rounded-xl px-3 py-1.5 text-app-ink-2 text-sm transition-colors hover:bg-app-surface-2 hover:text-app-ink-1 disabled:opacity-50"
            >
              <LogOut className="h-3.5 w-3.5" />
              Salir
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6 md:px-8">
        <Outlet />
      </main>
    </div>
  );
}
